class CollapsibleTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.collapsible-tabs__item');
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      const trigger = tab.querySelector('.collapsible-tabs__trigger');
      const content = tab.querySelector('.collapsible-tabs__content');

      if (trigger && content) {
        const shouldStartExpanded = trigger.getAttribute('aria-expanded') === 'true';
        // Set initial state
         if (shouldStartExpanded) {
          const contentInner = content.querySelector('.collapsible-tabs__content-inner');
          content.style.height = contentInner.offsetHeight + 'px';
        } else {
          content.style.height = '0';
        }

        // Add click event
        trigger.addEventListener('click', () => this.toggleTab(tab));
      }
    });
  }

  toggleTab(tab) {
    const trigger = tab.querySelector('.collapsible-tabs__trigger');
    const content = tab.querySelector('.collapsible-tabs__content');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    // Close all other tabs first
    this.tabs.forEach(otherTab => {
      if (otherTab !== tab) {
        const otherTrigger = otherTab.querySelector('.collapsible-tabs__trigger');
        const otherContent = otherTab.querySelector('.collapsible-tabs__content');
        
        if (otherTrigger && otherContent) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherContent.setAttribute('aria-hidden', 'true');
          otherContent.style.height = '0';
        }
      }
    });

    // Toggle current tab
    trigger.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    
    if (isExpanded) {
      content.style.height = '0';
    } else {
      const contentInner = content.querySelector('.collapsible-tabs__content-inner');
      content.style.height = contentInner.offsetHeight + 'px';
    }
  }
}

// Initialize for each section instance
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-collapsible-tabs');
  sections.forEach(section => {
    new CollapsibleTabs(section);
  });
});

// Handle Shopify section load events
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('section-collapsible-tabs')) {
    new CollapsibleTabs(event.target);
  }
});